import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { routesList } from "../routers";
import { checkPermission } from "./permissions";
// import { actions } from '../redux/store/store'
// import { useGetCurrentUserQuery } from '../api/auth'

const skipRedirect = (pathname) => ["/register", "/callback", "/forgotPassword", '/healthCheck', '/resetPassword/:hash', '/register/:hash', '/confirmation/:hash'].some((route) => {
  if (route.includes(':')) {
    const regex = new RegExp(`^${route.replace(/:\w+/g, '[^/]+')}$`);
    return regex.test(pathname);
  }
  return route === pathname;
});

const normalizePath = (path) => `/${String(path || "").replace(/^\/+/, "")}`;

const configuredRoutes = routesList.flatMap((route) =>
  route.subRoutes?.length ? route.subRoutes : [route]
);

const rolesForPath = (pathname) => {
  const route = configuredRoutes.find(({ path }) => {
    const configuredPath = normalizePath(path);
    return pathname === configuredPath ||
      (configuredPath === "/users" && pathname.startsWith("/users/")) ||
      (configuredPath === "/schedulers" && pathname.startsWith("/schedulers/"));
  });
  return route?.role;
};

const defaultPathForRole = (role) => {
  if (checkPermission(role, "drivers.view")) return "/drivers";
  const firstAllowedRoute = configuredRoutes.find((route) =>
    route.role?.includes(role)
  );
  return firstAllowedRoute
    ? normalizePath(firstAllowedRoute.path)
    : "/access-denied";
};

const AuthHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const currentUser = useSelector((state) => state.auth.currentUser);
  const isLoading = useSelector((state) => state.auth.isLoading);

  useEffect(() => {
    if (
      !currentUser &&
      isLoading === false &&
      !skipRedirect(pathname)
      && pathname !== '/login'
    ) {
      navigate("/login");
    } else if(
      currentUser && 
      ["/login", '/callback'].includes(pathname)
    ) {
      navigate(defaultPathForRole(currentUser.role), { replace: true });
    } else if (currentUser) {
      const allowedRoles = rolesForPath(pathname);
      if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
        navigate(defaultPathForRole(currentUser.role), { replace: true });
      }
    }
  }, [currentUser, isLoading, pathname, navigate]);

  return null;
};

export default AuthHandler;
